
import React from 'react';
import { MealInfo } from '../daily-tile';
import MealTypeSection from './MealTypeSection';
import { Button } from '@/components/ui/button';
import { Utensils } from 'lucide-react';

interface MealTypeSectionsProps {
  meals: MealInfo[];
  isLoading: boolean;
  onShowAllMeals: () => void;
  mealMode?: 'breakfast' | 'lunch' | 'dinner';
  hideBadge?: boolean;
}

const MealTypeSections: React.FC<MealTypeSectionsProps> = ({
  meals,
  isLoading,
  onShowAllMeals,
  mealMode = 'breakfast',
  hideBadge = false
}) => {
  if (isLoading) {
    return <p className="text-sm text-muted-foreground animate-pulse">Loading...</p>;
  }

  const filteredMeals = meals.filter(meal => meal.mealType === mealMode);

  return (
    <div className="w-full">
      <MealTypeSection
        type={mealMode}
        label={mealMode === 'breakfast' ? 'Breakfast' : mealMode === 'lunch' ? 'Lunch' : 'Dinner'}
        meals={filteredMeals}
        onShowAllMeals={onShowAllMeals}
        hideBadge={hideBadge}
      />
    </div>
  );
};

export default MealTypeSections;
